"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardKpiCore = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var dashboardContexts_1 = require("../../../dashboardContexts");
var model_1 = require("../../../../model");
var KpiExecutor_1 = require("./KpiExecutor");
var common_1 = require("../common");
/**
 * @internal
 */
exports.DashboardKpiCore = function (props) {
    var kpiWidget = props.kpiWidget, alert = props.alert, onFiltersChange = props.onFiltersChange, onDrill = props.onDrill, onError = props.onError, customBackend = props.backend, customWorkspace = props.workspace, CustomErrorComponent = props.ErrorComponent, CustomLoadingComponent = props.LoadingComponent;
    ts_invariant_1.default(kpiWidget.kpi, "The provided widget is not a KPI widget.");
    var _a = dashboardContexts_1.useDashboardComponentsContext({
        ErrorComponent: CustomErrorComponent,
        LoadingComponent: CustomLoadingComponent,
    }), ErrorComponent = _a.ErrorComponent, LoadingComponent = _a.LoadingComponent;
    var backend = sdk_ui_1.useBackendStrict(customBackend);
    var workspace = sdk_ui_1.useWorkspaceStrict(customWorkspace);
    var dashboardRef = model_1.useDashboardSelector(model_1.selectDashboardRef);
    var dashboardFilters = model_1.useDashboardSelector(model_1.selectFilterContextFilters);
    var disableDrillUnderline = model_1.useDashboardSelector(model_1.selectDisableKpiDashboardHeadlineUnderline);
    var separators = model_1.useDashboardSelector(model_1.selectSeparators);
    var isReadOnly = model_1.useDashboardSelector(model_1.selectIsReadOnly);
    var kpiData = common_1.useKpiData({ kpiWidget: kpiWidget, dashboardFilters: dashboardFilters });
    if (kpiData.status === "loading" || kpiData.status === "pending") {
        return react_1.default.createElement(LoadingComponent, null);
    }
    if (kpiData.status === "error") {
        return react_1.default.createElement(ErrorComponent, { message: kpiData.error.message });
    }
    return (react_1.default.createElement(KpiExecutor_1.KpiExecutor, { dashboardRef: dashboardRef, kpiWidget: kpiWidget, primaryMeasure: kpiData.result.primaryMeasure, secondaryMeasure: kpiData.result.secondaryMeasure, alert: alert, allFilters: kpiData.result.allFilters, effectiveFilters: kpiData.result.effectiveFilters, onFiltersChange: onFiltersChange, onDrill: onDrill, onError: onError, separators: separators, disableDrillUnderline: disableDrillUnderline, backend: backend, workspace: workspace, LoadingComponent: LoadingComponent, isReadOnly: isReadOnly }));
};
//# sourceMappingURL=DashboardKpiCore.js.map